import { Record, Map } from "immutable";
import moment from "moment";

const FormsRecord = Record({
  createPagesList: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    isAddModalVisible: false,
    fields: new (Record({
      name: "",
      slug: ""
    }))()
  }))(),
  createPagesListCategory: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    isAddModalVisible: false,
    fields: new (Record({
      name: "",
      tag: "",
      slug: "",
      locale: "",
      description: ""
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/pagesLists/forms.js